import { Link } from "react-router-dom";
import { ArrowUpRight, Users } from "lucide-react";
import { FacilityStatusBadge } from "@/components/StatusBadges";

export const FacilityCard = ({ facility, upcoming = 0, index = 0, large = false }) => (
  <Link
    to={`/strutture/${facility.slug}`}
    data-testid={`facility-card-${facility.slug}`}
    className="group fade-up flex flex-col overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-[box-shadow,transform] duration-200"
    style={{ animationDelay: `${index * 70}ms` }}
  >
    <div className={`relative overflow-hidden ${large ? "h-52" : "h-36"}`}>
      <img src={facility.image_url} alt={facility.name} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
      <div className="absolute left-3 top-3"><FacilityStatusBadge status={facility.status} testId={`facility-status-${facility.slug}`} /></div>
    </div>
    <div className="flex flex-1 flex-col p-5">
      <div className="flex items-start justify-between gap-3">
        <h3 className="font-serif text-2xl font-semibold leading-tight text-slate-900">{facility.name}</h3>
        <ArrowUpRight className="h-5 w-5 shrink-0 text-slate-400 group-hover:text-[#8B1E2B] transition-colors" />
      </div>
      <p className="mt-1 text-sm text-slate-500">{facility.event_types}</p>
      {facility.status !== "disponibile" && facility.status_note && (
        <p className="mt-3 rounded-md bg-amber-50 px-3 py-2 text-xs text-amber-800">{facility.status_note}</p>
      )}
      <div className="mt-auto pt-4 flex items-center justify-between border-t border-slate-100 text-xs text-slate-600">
        <span className="flex items-center gap-1.5"><Users className="h-3.5 w-3.5" />{facility.capacity} posti</span>
        <span className="font-mono" data-testid={`facility-upcoming-${facility.slug}`}>{upcoming} eventi in agenda</span>
      </div>
    </div>
  </Link>
);
